/**
 * Unsplash API compliance utilities
 * Docs: https://help.unsplash.com/en/articles/2511258-guideline-attribution
 */

/**
 * Generate proper attribution link with UTM parameters
 * @param {Object} photo - Unsplash photo object
 * @returns {string} Attribution URL with UTM parameters
 */
export function getAttributionUrl(photo) {
  if (!photo?.user?.username) return '';
  
  const baseUrl = `https://unsplash.com/@${photo.user.username}`;
  const utmParams = new URLSearchParams({
    utm_source: 'cultural-judaism', // Your app name
    utm_medium: 'referral'
  });
  
  return `${baseUrl}?${utmParams.toString()}`;
}

/**
 * Generate Unsplash homepage link with UTM parameters
 * @returns {string} Unsplash homepage URL with UTM parameters
 */
export function getUnsplashUrl() {
  const utmParams = new URLSearchParams({
    utm_source: 'cultural-judaism',
    utm_medium: 'referral'
  });
  
  return `https://unsplash.com/?${utmParams.toString()}`;
}

/**
 * Trigger download tracking (required by Unsplash API)
 * Call this when user selects/downloads/uses an image
 * @param {string} downloadLocation - photo.links.download_location from API
 */
export async function triggerDownload(downloadLocation) {
  if (!downloadLocation) {
    console.error('No download location provided');
    return;
  }
  
  try {
    // This must include your Unsplash API access key
    const response = await fetch(downloadLocation, {
      headers: {
        'Authorization': `Client-ID ${process.env.REACT_APP_UNSPLASH_ACCESS_KEY}`
      }
    });
    
    if (!response.ok) {
      console.error('Failed to trigger download:', response.status);
    }
    
    // Note: You don't need to do anything with the response
    // Just making the request increments the download counter
  } catch (error) {
    console.error('Error triggering download:', error);
  }
}

/**
 * Format photographer name for display
 * @param {Object} user - Unsplash user object
 * @returns {string} Formatted photographer name
 */
export function getPhotographerName(user) {
  return user?.name || user?.username || 'Unknown';
}

